import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardService } from '../dashboard.service';
import { TranslateService } from '../../../services/translate.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-created-journals-widget',
  imports: [CommonModule],
  templateUrl: './journal-moves-widget.component.html',
  styleUrls: ['./journal-moves-widget.component.scss']
})
export class JournalMovesWidgetComponent implements OnInit {
  @Input() callerName?: string;

  @Input() inDialog = false; // not used here, kept for compatibility

  totalJournalMoves: number | null = null;
  lastMonthJournalMoves: number | null = null;
  allApiData: Record<string, any[]> = {};

  loading = false;
  error: string | null = null;

  constructor(private dashboardService: DashboardService, public translateServ: TranslateService) {}

  ngOnInit(): void {
	const caller = this.callerName ?? this.constructor.name.substring(1);
	this.loadData(caller);
  }

  loadData(caller: string) {
	this.loading = true;
	this.error = null;

	this.dashboardService.getExtendedData(caller)
	  .pipe(
		catchError(err => {
		  console.error('JournalMovesWidgetComponent - API error', err);
		  this.error = 'Failed to load';
		  this.loading = false;
		  return of(null);
		})
	  )
	  .subscribe((data: any) => {
		this.loading = false;
		if (!data) return;
		this.allApiData = data;
		
		// Fill values according to the API structure you posted earlier
		this.totalJournalMoves = data?.Table?.[0]?.Total ?? 0;

		// Use Table3 for last month's data
		this.lastMonthJournalMoves = data?.Table3?.[0]?.Total_Movein_Rows_in_Current_Month ?? 0;
	  });
  }
}
